import { ContextMenu as MenuPrimitive } from 'radix-ui';
import type { ComponentProps, ReactNode } from 'react';

import { cn } from '../lib/cn.ts';
import { Shortcut } from './kbd.tsx';

export const ContextMenu = MenuPrimitive.Root;
export const ContextMenuTrigger = MenuPrimitive.Trigger;

/** Меню по правому клику: Radix сам ставит его в позицию курсора. */
export function ContextMenuContent({ className, ...props }: ComponentProps<typeof MenuPrimitive.Content>) {
  return (
    <MenuPrimitive.Portal>
      <MenuPrimitive.Content
        className={cn(
          'z-[var(--g-float-z)] min-w-48 rounded-lg border-thick border-border bg-surface p-1 text-text shadow-float',
          'origin-(--radix-context-menu-content-transform-origin)',
          'data-[state=closed]:pointer-events-none data-[state=closed]:animate-pop-out data-[state=open]:animate-pop-in',
          className,
        )}
        {...props}
      />
    </MenuPrimitive.Portal>
  );
}

const itemClass =
  'relative flex cursor-default items-center gap-2 rounded-sm px-2 py-1.5 font-semibold outline-none select-none ' +
  'data-[highlighted]:bg-surface-2 data-[disabled]:opacity-45 [&_svg]:size-4 [&_svg]:text-muted';

export function ContextMenuItem({
  className,
  icon,
  shortcut,
  danger,
  children,
  ...props
}: ComponentProps<typeof MenuPrimitive.Item> & {
  icon?: ReactNode;
  shortcut?: readonly string[];
  danger?: boolean;
}) {
  return (
    <MenuPrimitive.Item
      className={cn(itemClass, danger && 'text-danger [&_svg]:text-danger', className)}
      {...props}
    >
      {icon}
      <span className="flex-1">{children}</span>
      {shortcut ? <Shortcut keys={shortcut} /> : null}
    </MenuPrimitive.Item>
  );
}

export function ContextMenuSeparator({
  className,
  ...props
}: ComponentProps<typeof MenuPrimitive.Separator>) {
  return <MenuPrimitive.Separator className={cn('my-1 h-px bg-border-soft', className)} {...props} />;
}
